"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    useAvatarGroup_unstable: ()=>useAvatarGroup_unstable,
    defaultAvatarGroupSize: ()=>defaultAvatarGroupSize
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _reactUtilities = require("@fluentui/react-utilities");
const useAvatarGroup_unstable = (props, ref)=>{
    const { layout ='spread' , size =defaultAvatarGroupSize  } = props;
    const root = (0, _reactUtilities.getNativeElementProps)('div', {
        role: 'group',
        ...props,
        ref
    }, [
        'size'
    ]);
    return {
        layout,
        size,
        components: {
            root: 'div'
        },
        root
    };
};
const defaultAvatarGroupSize = 32; //# sourceMappingURL=useAvatarGroup.js.map

//# sourceMappingURL=useAvatarGroup.js.map